import { LineItem } from "@made-people/grease-cart";
import { ProductWithVariants } from "@made-people/grease-product";
import { getVariantStockDeliveryData } from "../components/features/delivery-status/get-stock-delivery-data";
import { parseWarehouseStatus } from "../services/centra/mappers/utils/parse-warehouse-status";
import { AllocationRuleInfo } from "../components/features/delivery-status/out-of-stock-information";

export const isAllCartItemsOMG = (
  items: LineItem[],
  countryCode: string,
  allocationRule: AllocationRuleInfo,
): boolean => {
  for (const item of items) {
    if (item.type !== "product") {
      continue;
    }

    const product = item.product;

    if (product.dataModel !== "with_variants") {
      continue;
    }

    const productWithVariants = product as ProductWithVariants;
    const variant = productWithVariants.variants.find(
      (v) => v.variantId === item.id,
    );

    if (!variant) {
      return false;
    }

    const stockData = getVariantStockDeliveryData(product.base, countryCode);

    if (!stockData) {
      return false;
    }

    if (allocationRule.hasLitWarehouse) {
      const litStatus = parseWarehouseStatus(
        stockData.litWarehouseStatus,
        variant.label,
        stockData.tableMapping,
      );

      if (litStatus !== "OMG") {
        return false;
      }
    } else {
      const status100 = parseWarehouseStatus(
        stockData.warehouse100Status,
        variant.label,
        stockData.tableMapping,
      );

      if (status100 !== "OMG") {
        return false;
      }
    }
  }

  return true;
};
